<template>
  <div class="unsubscribe">
    <div class="unsubscribe--background" :style="getBackground"></div>
    <div class="unsubscribe--container">
      <CofocusLogo customStyle="transform:scale(1.2); margin-left:-6px;" />
      <div class="unsubscribe--title">You've been unsubscribed.</div>
      <div class="unsubscribe--footer--text">No more marketing emails will be sent your way.</div>
      <img class="unsubscribe--gif" src="https://ik.imagekit.io/elysiumone/Official/unsubscribe1_Rnf-BXxNK.webp?updatedAt=1706229639891" />
      <div class="unsubscribe--footer">
        <ELYXButton @click="goToSettings" fontWeight="400">Manage email preferences</ELYXButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UnsubscribeAPI from "./UnsubscribeAPI";
import CofocusLogo from "../Nav/CofocusLogo.vue";
import ELYXButton from "../../ELYXComponents/ELYXButton.vue";

export default {
  name: "Unsubscribe",
  components: {
    CofocusLogo,
    ELYXButton,
  },
  created() {
    this.unsubscribeUserFromEmailType();
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      styles: (state) => state.style.styles,
    }),
    getBackground() {
      if (this.user && this.styles && this.styles.background) {
        return `background-image: ${this.styles.background}`;
      } else {
        return `background-image: url("https://images.unsplash.com/photo-1579539511891-7ce608434fb4")`;
      }
    },
  },
  methods: {
    goToSettings() {
      if (this.user) {
        window.location.href = "/?settings=email";
      } else {
        window.location.href = "/account/login";
      }
    },
    async unsubscribeUserFromEmailType() {
      try {
        const unsubscribeEncryption = this.$route.query.unsubscribeEncryption;
        if (!unsubscribeEncryption) {
          throw new Error("No unsubscribe hash found in url.");
        }
        const response = await UnsubscribeAPI.unsubscribeUserFromEmailType(unsubscribeEncryption);
        if (!response || !response.success) {
          throw new Error("Unsubscribe request failed.");
        }
      } catch (error) {
        window.mixpanel.track("ERROR", {
          UID: this.user && this.user._id ? this.user._id : "N/A",
          type: "UNSUBSCRIBE_FROM_EMAIL",
          unsubscribeEncryption: this.$route.query.unsubscribeEncryption ? this.$route.query.unsubscribeEncryption : "N/A",
        });
        alert(
          "If you're seeing this, something unknown to us went wrong. Please reach out to us at support@cofocus.one and we'll quickly make sure to manually unsubscribe you. Alternatively, you can also manage your email preferences through your account settings."
        );
      }
    },
  },
};
</script>

<style>
.unsubscribe {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  position: relative;
}
.unsubscribe--container {
  border-radius: 16px;
  max-width: 430px;
  width: 100%;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-bottom: 15px;
  border: 1px solid #ffffff1a;
  box-sizing: border-box;
  background-color: rgb(255 255 255 / 50%) !important;
  box-shadow: 0 0 0 1px rgba(15, 15, 15, 0.05), 0 3px 6px rgba(15, 15, 15, 0.1), 0 9px 24px hsla(0, 0%, 83.5%, 0.2);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.unsubscribe--title {
  font-size: 20px;
  margin-top: 30px;
  font-weight: 500;
}
.unsubscribe--gif {
  width: 400px;
  margin: 15px;
  margin-top: 10px;
  border-radius: 16px;
}
.unsubscribe--footer {
  width: 400px;
}
.unsubscribe--footer--text {
  line-height: 22px;
  font-size: 16px;
  margin-top: 10px;
  text-align: center;
}
.unsubscribe--background {
  height: 100vh;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-size: 100% 100%;
}
@media (max-height: 436px) {
  .unsubscribe--container {
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
